/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Assignment } from '../models/assignment';
@Injectable({
  providedIn: 'root',
})
class AssignmentsService extends __BaseService {
  static readonly AssignmentsGetPath = '/assignments/{assignmentId}';
  static readonly AssignmentsDeletePath = '/assignments/{assignmentId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns information about the assignment
   * @param params The `AssignmentsService.AssignmentsGetParams` containing the following parameters:
   *
   * - `assignmentId`: GUID of the assignment
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  AssignmentsGetResponse(params: AssignmentsService.AssignmentsGetParams): __Observable<__StrictHttpResponse<Assignment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/assignments/${encodeURIComponent(String(params.assignmentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Assignment>;
      })
    );
  }
  /**
   * Returns information about the assignment
   * @param params The `AssignmentsService.AssignmentsGetParams` containing the following parameters:
   *
   * - `assignmentId`: GUID of the assignment
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  AssignmentsGet(params: AssignmentsService.AssignmentsGetParams): __Observable<Assignment> {
    return this.AssignmentsGetResponse(params).pipe(
      __map(_r => _r.body as Assignment)
    );
  }

  /**
   * Deletes an assignment
   * @param params The `AssignmentsService.AssignmentsDeleteParams` containing the following parameters:
   *
   * - `assignmentId`: GUID of the assignment
   *
   * - `Authorization`: Bearer JSON Web Token
   */
  AssignmentsDeleteResponse(params: AssignmentsService.AssignmentsDeleteParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/assignments/${encodeURIComponent(String(params.assignmentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Deletes an assignment
   * @param params The `AssignmentsService.AssignmentsDeleteParams` containing the following parameters:
   *
   * - `assignmentId`: GUID of the assignment
   *
   * - `Authorization`: Bearer JSON Web Token
   */
  AssignmentsDelete(params: AssignmentsService.AssignmentsDeleteParams): __Observable<null> {
    return this.AssignmentsDeleteResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

namespace AssignmentsService {

  /**
   * Parameters for AssignmentsGet
   */
  export interface AssignmentsGetParams {

    /**
     * GUID of the assignment
     */
    assignmentId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }

  /**
   * Parameters for AssignmentsDelete
   */
  export interface AssignmentsDeleteParams {

    /**
     * GUID of the assignment
     */
    assignmentId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { AssignmentsService }